module.exports = __webpack_public_path__ + "static/media/Step 3.8d7c434a.mp3";